// extracted by mini-css-extract-plugin
module.exports = {"status":"StateIcon_status__2HSG-","tag":"StateIcon_tag__1xj34","dot":"StateIcon_dot__1DYIs"};